export const SERVICE_STATUSES = ["(No Status)", "Standard Service", "Priority Service", "Waiting", "In Shop", "Ready to Re-Deliver", "Complete", "Archive"];
export const DEFAULT_SERVICE_STATUSES = SERVICE_STATUSES.filter(s => !["Complete", "Archive"].includes(s));

export function serviceCallStatus(call) {
  const raw = typeof call === "string" ? call : (call?.airtable_status || call?.status || "");
  if (typeof call !== "string" && ["in_shop", "shop_work_incomplete", "ready_to_redeliver"].includes(call?.status)) return "In Shop";
  if (["Shop Work Incomplete", "In Shop"].includes(raw)) return "In Shop";
  if (raw === "Need to Close out") return "Standard Service";
  if (raw === "Duplicate/Delete") return "Archive";
  return raw;
}

export const shopWorkOutcome = call => call?.shop_work_status || ({ shop_work_incomplete: "incomplete", ready_to_redeliver: "complete" }[call?.status]) ||
  (call?.airtable_status === "Shop Work Incomplete" ? "incomplete" : "pending");
export const SHOP_OUTCOME_LABELS = { pending: "Pending", incomplete: "Incomplete", complete: "Complete" };
export const normalizeStatusFilter = values => [...new Set(values.map(serviceCallStatus).filter(s => SERVICE_STATUSES.includes(s)))];